/** Imported from `cms` */

import { defaultAggregations } from "../fragments";

export const searchUserResources = /* GraphQL */ `
  query SearchUserResources(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $aggs: [SearchableResourceAggsInput!]
    $limit: Int
    $nextToken: String
    $authorizationContext: AuthorizationContextInput
  ) {
    searchUserResources(
      filter: $filter
      sort: $sort
      aggs: $aggs
      limit: $limit
      nextToken: $nextToken
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        idInc
        sk
        type
        version
        bankId
        name
        description
        author
        maturity
        subject
        grade
        dok
        language
        blooms
        excerpt
        interaction
        itemCount
        dimensions {
          width
          height
          scale
        }
        file {
          name
          key
          size
        }
        dueAt
        editorId
        creatorId
        questionIds
        contextIds
        alignmentIds
        creator {
          id
          firstName
          lastName
          avatarHash
        }
        assigneeId
        assignee {
          id
          firstName
          lastName
          avatarHash
        }
        reviewerId
        reviewer {
          id
          firstName
          lastName
          avatarHash
        }
        schemaVersion
        reviews {
          maturity
          creatorId
          creator {
            firstName
            lastName
            avatarHash
          }
        }
        tags {
          key
          type
          value
        }
        stats
        statsAt
        createdAt
        updatedAt
        isCreating
        isArchived
        isDeleted
        workspaceId
        isUserFavorite
        isUserWatcher
        __typename
      }
      nextToken
      ${defaultAggregations}
      total
      __typename
    }
  }
`;

export const searchVocabulary = /* GraphQL */ `
  query SearchVocabulary(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $limit: Int
    $nextToken: String
    $authorizationContext: AuthorizationContextInput
  ) {
    searchUserResources: searchVocabulary(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      authorizationContext: $authorizationContext
    ) {
      total
      nextToken
      items {
        id
        sk
        workspaceId
        name
        bankId
        description
        grade
        subject
        tags {
          key
          type
          value
        }
        usages {
          count
          items {
            item {
              courseId
              grade
            }
          }
        }
      }
    }
  }
`;

export const searchResources = `
  query SearchUserResources(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $limit: Int
    $nextToken: String
    $authorizationContext: AuthorizationContextInput
  ) {
    searchUserResources(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        idInc
        idVendor
        sk
        type
        version
        bankId
        name
        description
        author
        maturity
        subject
        grade
        rmm
        lexile
        flesch
        parccTextComplexity
        wordCount
        language
        excerpt
        dueAt
        editorId
        creatorId
        questionIds
        schemaVersion
        createdAt
        updatedAt
        workspaceId
        isUserFavorite
        isUserWatcher
        isCreating
        isUnlisted
        visibility
        itemCount
        file {
          name
          bucket
          key
          size
        }
        dimensions {
          width
          height
          scale
        }
        tags {
          key
          type
          value
        }
        __typename
      }
      nextToken
      ${defaultAggregations}
    }
  }
`;

export const searchFavorites = `
  query SearchUserResources(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $limit: Int
    $nextToken: String
    $authorizationContext: AuthorizationContextInput
  ) {
    searchUserResources(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        idInc
        sk
        type
        bankId
        name
        maturity
        createdAt
        updatedAt
        workspaceId
        isUserFavorite
        isUserWatcher
        __typename
      }
      nextToken
      ${defaultAggregations}
    }
  }
`;

export const createResourceFavorite = /* GraphQL */ `
  mutation CreateResourceFavorite($input: CreateResourceFavoriteInput!) {
    createResourceFavorite(input: $input) {
      id
      sk
      createdAt
      updatedAt
    }
  }
`;

export const deleteResourceFavorite = /* GraphQL */ `
  mutation DeleteResourceFavorite($input: DeleteResourceFavoriteInput!) {
    deleteResourceFavorite(input: $input) {
      id
      sk
      createdAt
      updatedAt
    }
  }
`;

export const incrementWorkspaceCounter = /* GraphQL */ `
  mutation IncrementWorkspaceCounter($input: IncrementWorkspaceCounterInput) {
    incrementWorkspaceCounter(input: $input) {
      id
      sk
      counter
    }
  }
`;

export const updateWorkspaceSubscription = /* GraphQL */ `
  mutation UpdateWorkspaceSubscription(
    $input: UpdateWorkspaceSubscriptionInput!
  ) {
    updateWorkspaceSubscriptionForWorkspace(input: $input) {
      id
      sk
      customerId
      product {
        type
        name
        unitPrice
        units
        priceId
        updatedAt
      }
      billing {
        method {
          id
          type
          card {
            brand
            expMonth
            expYear
            last4
          }
          createdAt
        }
        contact {
          address1
          address2
          country
          city
          region
          postalCode
          phone
          email
        }
      }
    }
  }
`;

export const createResource = `
  mutation CreateResource($input: CreateResourceInput!) {
    createResource(input: $input) {
      id
      idInc
      sk
      type
      name
      description
      schemaVersion
      workspaceId
    }
  }
`;

export const updateResource = `
  mutation UpdateResource($input: UpdateResourceInput!) {
    updateResource(input: $input) {
      id
      idInc
      sk
      type
      name
      description
      schemaVersion
      maturity
      workspaceId
    }
  }
`;

export const deleteResource = `
  mutation DeleteResource($input: DeleteResourceInput!) {
    deleteResource(input: $input) {
      id
      idInc
      sk
      type
      name
      description
      schemaVersion
      workspaceId
    }
  }
`;

export const getResource = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      idInc
      idVendor
      sk
      name
      blueprintSpecs
      name
      maturity
      type
    }
  }
`;

export const getResourceSearchResult = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      idInc
      idVendor
      sk
      type
      version
      bankId
      name
      description
      author
      maturity
      subject
      grade
      rmm
      lexile
      flesch
      parccTextComplexity
      wordCount
      language
      excerpt
      dueAt
      editorId
      creatorId
      questionIds
      schemaVersion
      createdAt
      updatedAt
      workspaceId
      isUserFavorite
      isUserWatcher
      contextIds
      alignmentIds
      isUserFavorite
      isUserWatcher
      file {
        name
        region
        bucket
        key
        size
        mimetype
        format
        extension
      }
      tags {
        key
        type
        value
      }
      __typename
    }
  }
`;

export const getBlueprint = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      idInc
      idVendor
      sk
      name
      description
      blueprintSpecs
      maturity
      stats
      createdAt
      updatedAt
      assigneeId
      reviewerId
    }
  }
`;

export const getTask = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      idInc
      idVendor
      sk
      name
      description
      maturity
      createdAt
      updatedAt
      creatorId
      assigneeId
      reviewerId
      dueAt
      type
      workspaceId
      blueprintIds
      resourceId
      config
      resource {
        id
        sk
        idInc
        name
        description
      }
      creator {
        id
        firstName
        lastName
        avatarHash
      }
      assignee {
        id
        firstName
        lastName
        avatarHash
      }
      reviewer {
        id
        firstName
        lastName
        avatarHash
      }
      blueprints {
        id
        sk
        name
        blueprintSpecs
      }
      isUserWatcher
    }
  }
`;

export const listResources = /* GraphQL */ `
  query ListResources(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResources(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        idInc
        sk
        type
        name
        description
        schemaVersion
        resourceId
        resource {
          id
          sk
          name
          idInc
          maturity
        }
        workspaceId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listRelatives = /* GraphQL */ `
  query ListResources(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResources(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        idInc
        sk
        schemaVersion
        resourceId
        resource {
          id
          sk
          idInc
          name
          maturity
        }
      }
      nextToken
    }
  }
`;

export const listSubTasks = /* GraphQL */ `
  query ListSubTasks(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResources(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sk
        idInc
        resource {
          id
          sk
          idInc
          name
          createdAt
          updatedAt
          maturity
          priority
          dueAt
          workspaceId
          assignee {
            firstName
            lastName
            avatarHash
            id
          }
        }
      }
    }
  }
`;

export const listProofs = /* GraphQL */ `
  query ListResources(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResources(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        idInc
        sk
        type
        name
        description
        schemaVersion
        workspaceId
        resourceId
        createdAt
        updatedAt
        alignments {
          items {
            id
            sk
            abbreviation
            content
            guid
            idAuthority
            name
            scope
            sequence
            type
          }
        }
        resource {
          id
          sk
          idInc
          name
          maturity
          subject
          grade
        }
        maturity
        dimensions {
          width
          height
          scale
        }
        creator {
          firstName
          lastName
          avatarHash
        }
        file {
          name
          region
          bucket
          key
          size
          mimetype
          format
          extension
        }
        tags {
          key
          type
          value
        }
      }
      nextToken
    }
  }
`;

export const listResourcesByWorkspaceId = /* GraphQL */ `
  query ListResourcesByWorkspaceId(
    $workspaceId: String
    $sk: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResourcesByWorkspaceId(
      workspaceId: $workspaceId
      sk: $sk
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        idInc
        idVendor
        sk
        type
        version
        name
        description
      }
      nextToken
    }
  }
`;

export const createWorkspace = /* GraphQL */ `
  mutation CreateWorkspace($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      id
      sk
      name
    }
  }
`;

export const updateWorkspace = /* GraphQL */ `
  mutation UpdateWorkspace($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      id
      sk
      name
    }
  }
`;

export const listUsers = /* GraphQL */ `
  query ListWorkspaceUsers($input: ModelListInput) {
    listWorkspaceUsers(input: $input) {
      items {
        id
        sk
        name
        description
        createdAt
        updatedAt
        isDisabled
        isDeleted
        acl
        user {
          id
          sk
          firstName
          lastName
          avatarHash
          email
        }
        roles {
          id
          sk
          name
          acl
        }
      }
      nextToken
    }
  }
`;

export const listUserInvitations = /* GraphQL */ `
  query ListWorkspaceUserInvitations($input: ModelListInput) {
    listWorkspaceUserInvitations(input: $input) {
      items {
        id
        sk
        name
        description
        createdAt
        updatedAt
        isDisabled
        isDeleted
        invitationId
        user {
          id
          sk
          firstName
          lastName
          avatarHash
        }
      }
      nextToken
    }
  }
`;

export const listRoles = /* GraphQL */ `
  query ListWorkspaces($input: ModelListInput) {
    listWorkspaceRoles(input: $input) {
      items {
        id
        sk
        name
        description
        createdAt
        updatedAt
        isDisabled
        isDeleted
        user {
          id
          sk
          firstName
          lastName
          avatarHash
        }
      }
      nextToken
    }
  }
`;

export const listBanks = /* GraphQL */ `
  query ListBanks($input: ModelListInput) {
    listBanks(input: $input) {
      items {
        id
        sk
        name
        description
        createdAt
        updatedAt
        isDisabled
        isDeleted
      }
      nextToken
    }
  }
`;

export const getWorkspace = /* GraphQL */ `
  query GetWorkspace($input: ModelGetInput) {
    getWorkspace(input: $input) {
      id
      sk
      name
      description
      createdAt
      updatedAt
      acl
      isDisabled
    }
  }
`;

export const getRole = /* GraphQL */ `
  query GetWorkspace($input: ModelGetInput) {
    getWorkspace(input: $input) {
      id
      sk
      name
      description
      createdAt
      updatedAt
      acl
      isDisabled
      isDeleted
      updatedAt
      createdAt
    }
  }
`;

export const getWorkspaceUser = /* GraphQL */ `
  query GetWorkspace($input: ModelGetInput) {
    getWorkspace(input: $input) {
      id
      sk
      name
      description
      createdAt
      updatedAt
      acl
      isDisabled
      isDeleted
      lastActiveAt
      roleIds
      roles {
        acl
        name
        id
        sk
      }
      tags {
        key
        value
      }
      user {
        id
        sk
        firstName
        lastName
        avatarHash
        email
      }
    }
  }
`;

export const listWorkspacesBySortKey = /* GraphQL */ `
  query ListWorkspacesBySortKey(
    $sk: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkspacesBySortKey(
      sk: $sk
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sk
        name
        description
        createdAt
        updatedAt
        lastActiveAt
        acl
        user {
          id
          sk
          firstName
          lastName
          avatarHash
        }
        workspace {
          id
          sk
          name
          description
        }
      }
      nextToken
    }
  }
`;

export const createObjective = /* GraphQL */ `
  mutation CreateObjective($input: CreateObjectiveInput!) {
    createObjective(input: $input) {
      id
      sk
      guid
      type
      name
      content
      numRaw
      numEnhanced
      sequence
      idAuthority
      idPublisher
      objectiveTree
    }
  }
`;

export const updateObjective = /* GraphQL */ `
  mutation UpdateObjective($input: UpdateObjectiveInput!) {
    updateObjective(input: $input) {
      id
      sk
      guid
      type
      name
      content
      numRaw
      numEnhanced
      sequence
      idAuthority
      idPublisher
      objectiveTree
    }
  }
`;

export const deleteObjective = /* GraphQL */ `
  mutation DeleteObjective($input: DeleteObjectiveInput!) {
    deleteObjective(input: $input) {
      id
      sk
      guid
      type
      name
      content
      numRaw
      numEnhanced
      sequence
      idAuthority
      idPublisher
    }
  }
`;

export const listObjectives = /* GraphQL */ `
  query ListObjectives(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelObjectiveFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listObjectives(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sk
        guid
        type
        name
        content
        numRaw
        numEnhanced
        sequence
        idAuthority
        idPublisher
        parentId
        scope
        objectiveTree
        workflowStatus
        isObsolete
      }
    }
  }
`;

export const getObjective = /* GraphQL */ `
  query GetObjective($id: ID!, $sk: String!) {
    getObjective(id: $id, sk: $sk) {
      id
      sk
      guid
      type
      name
      content
      notes
      annotations {
        label
        content
      }
      numRaw
      numEnhanced
      sequence
      idAuthority
      idPublisher
      parentId
      scope
      objectiveTree
      workflowStatus
      tags {
        key
        type
        value
      }
    }
  }
`;
